import React, { Component, ReactElement } from 'react';
import { View, Text, TouchableOpacity, TextInput, TouchableWithoutFeedback } from 'react-native';
import { QSendNotification, Toast } from 'qunar-react-native';
import { observer, inject } from 'mobx-react/native';
import throttle from 'lodash.throttle';
import Icon from '../../../components/Icon';
// import getQpVersion from '../../../utils/getQpVersion';
import generateRNUrl from '../../../utils/generateRNUrl';
import styles from './style';
import { toast } from '../../../utils/toast';
import { navigate } from '../../../utils/navigate';
import InputAreaInterface from '../../../stores/inputTelephoneNum/inputArea';
import QAVStoreInterface from '../../../stores/inputTelephoneNum/qavStore';
import { Colors } from '@qnpm/q-theme';

const { scenes:{ baseColor } } = Colors;

// const qpVersion = getQpVersion();

interface Props {
    inputArea?: InputAreaInterface;
    qav?: QAVStoreInterface;
}

@inject('inputArea', 'qav')
@observer
class InputArea extends Component<Props> {
    public selectCountryListener: any;
    public countDownTimer: any;

    public telInput: any;
    public vCodeInput: any;

    public state = {
        second: 60,
        buttonText: '发送验证码'
    };
    /* 发送短信验证码 */
    public sendMobileCode = throttle(async () => {
        const { inputArea, qav } = this.props;
        /* 是否已输入手机号 */
        if (inputArea.buttonDisable) {
            return;
        }
        const { status, data, message } = await inputArea.fetchVCodeSendData().catch(() => ({
            message: '网络繁忙'
        }));
        const res = status === 0 && data;
        if (res) {
            qav.toast('验证码发送成功');
            toast({
                msg: '验证码发送成功',
                position: Toast.MIDDLE
            });
            this.startCountDown();
        } else {
            qav.toast(message);
            toast({
                msg: message,
                position: Toast.MIDDLE
            });
        }
    }, 800);

    /* 验证手机号及验证码，成功后跳转到搜索结果页面 */
    public validateTelAndVCode = throttle(async () => {
        const { inputArea, qav } = this.props;

        if (inputArea.confirmDisable) {
            return;
        }

        qav.send({
            module: 'query order',
            operType: 'click'
        });

        const { status, data, message } = await inputArea.fetchVCodeValidateData().catch(() => ({
            message: '网络繁忙'
        }));

        if (status === 0) {
            // this.resetPageData();
            const initProps = {
                param: {
                    ordertoken: data,
                    queryYear: inputArea.currentSelectYear
                }
            };
            const schema = generateRNUrl('SearchResult', undefined, initProps);
            navigate(
                {
                    isSchema: true,
                    schema
                },
                () => {}
            );
        } else {
            const msg = message || '验证码不正确';
            qav.toast(msg);
            toast({
                msg,
                position: Toast.MIDDLE
            });
        }
    }, 2000);

    /* 增加国别码监听 */
    public addCountryNotification = () => {
        const { inputArea, qav } = this.props;
        const { updateCountryCodeValue } = inputArea;
        QSendNotification.addNotification({
            name: 'cmnOrderRn-selectCountry-change',
            subscriptionCallback: (subscription) => {
                this.selectCountryListener = subscription;
            },
            dataCallback: (data: any) => {
                if (data.prenum) {
                    updateCountryCodeValue(data.prenum);
                }
                QSendNotification.removeNotification({
                    name: 'cmnOrderRn-selectCountry-change',
                    subscription: this.selectCountryListener,
                    errorCallback: (res) => {
                        qav.toast(res.error);
                        toast({
                            msg: res.error
                        });
                    }
                });
            },
            errorCallback: (res) => {
                qav.toast(res.error);
                toast({
                    msg: res.error
                });
            }
        });
    };

    /* 开始倒计时 */
    public startCountDown = () => {
        const { inputArea } = this.props;
        const { updateIsMsgSentWaiting } = inputArea;
        updateIsMsgSentWaiting(true);
        this.setState({
            buttonText: '60s后重发'
        });
        this.countDownTimer = setInterval(() => {
            const { second } = this.state;
            /* 倒计时 60s 后 */
            if (second === 1) {
                this.setState({
                    second: 60,
                    buttonText: '重新发送'
                });
                clearInterval(this.countDownTimer);
                updateIsMsgSentWaiting(false);
                return;
            }
            /* 倒计时 */
            const current = second - 1;
            this.setState({
                second: current,
                buttonText: `${current}s后重发`
            });
        }, 1000);
    };

    public resetPageData = () => {
        const { inputArea } = this.props;
        this.vCodeInput.clear();
        clearInterval(this.countDownTimer);
        inputArea.updateIsMsgSentWaiting(false);
        inputArea.updateVerificationValue('');
        this.setState({
            buttonText: '发送验证码',
            second: 60
        });
    };

    public render() {
        const {
            inputArea: {
                currentSelectYear,
                countryCode,
                telephoneNum,
                verificationValue,
                buttonDisable,
                confirmDisable,
                updateTelephoneValue,
                updateVerificationValue
            },
            qav
        } = this.props;

        const { buttonText } = this.state;
        return (
            <View style={styles.queryContent}>
                {/* 年份选择 */}
                <View style={styles.inputItem}>
                    <TouchableOpacity
                        onPress={() => {
                        }}
                        style={styles.countrySelectWrapper}
                    >
                        <View style={styles.countrySelectCont}>
                            <Text style={styles.countrySelectText}>年份</Text>
                            <Icon style={styles.countrySelectIcon} code="&#xf03e;" />
                        </View>
                    </TouchableOpacity>
                    <View style={styles.textInput}>
                        <Text
                            onPress={()=>{
                                this.props.inputArea.isShowTimePicker = true;
                            }}
                            style={styles.inputLabel}
                        >
                            {String(currentSelectYear)}
                        </Text>
                    </View>
                </View>
                {/* 手机号码输入 */}
                <View style={styles.inputItem}>
                    <TouchableOpacity
                        onPress={() => {
                            qav.send({
                                module: 'countryNum',
                                operType: 'click'
                            });
                            const schema = generateRNUrl('SelectCountry');
                            navigate({
                                isSchema: true,
                                schema
                            });
                            this.addCountryNotification();
                        }}
                        style={styles.countrySelectWrapper}
                    >
                        <View style={styles.countrySelectCont}>
                            <Text style={styles.countrySelectText}>{`+${countryCode}`}</Text>
                            <Icon style={styles.countrySelectIcon} code="&#xf03e;" />
                        </View>
                    </TouchableOpacity>
                    <View style={styles.textInput}>
                        <TextInput
                            onFocus={() => {
                                qav.send({
                                    module: 'PhoneNum',
                                    operType: 'click'
                                });
                            }}
                            ref={(ref) => {
                                this.telInput = ref;
                            }}
                            style={styles.inputLabel}
                            clearButtonMode="while-editing"
                            keyboardType="phone-pad"
                            underlineColorAndroid="transparent"
                            returnKeyType="done"
                            placeholder="请填写订单联系人手机号"
                            placeholderTextColor={baseColor.text3}
                            onChangeText={updateTelephoneValue}
                            selectionColor="#00BCD4"
                            textContentType="telephoneNumber"
                            autoFocus={false}
                            value={telephoneNum}
                        />
                    </View>
                </View>
                {/* 短信验证码输入 */}
                <View style={styles.inputItem}>
                    <View style={styles.inputTitle}>
                        <Text>验证码</Text>
                    </View>
                    <View style={styles.textInput}>
                        <TextInput
                            onFocus={() => {
                                qav.send({
                                    module: 'Enter Code',
                                    operType: 'click'
                                });
                            }}
                            ref={(ref) => {
                                this.vCodeInput = ref;
                            }}
                            autoFocus={false}
                            style={styles.inputLabel}
                            clearButtonMode="while-editing"
                            underlineColorAndroid="transparent"
                            keyboardType="phone-pad"
                            placeholder="请填写验证码"
                            placeholderTextColor={baseColor.text3}
                            maxLength={6}
                            value={verificationValue}
                            textContentType="telephoneNumber"
                            returnKeyType="done"
                            onChangeText={updateVerificationValue}
                        />
                    </View>
                    <TouchableWithoutFeedback onPress={this.sendMobileCode}>
                        <View
                            style={[
                                styles.buttonWrapper,
                                buttonDisable ? styles.buttonDisableView : {}
                            ]}
                        >
                            <Text
                                style={[
                                    styles.buttonText,
                                    buttonDisable ? styles.buttonDisableText : {}
                                ]}
                            >
                                {buttonText}
                            </Text>
                        </View>
                    </TouchableWithoutFeedback>
                </View>
                {/* 确认按钮 */}
                {confirmDisable ? (
                    <View style={[styles.confirm, styles.confirmDisableView]}>
                        <Text style={styles.confirmText}>查询订单</Text>
                    </View>
                ) : (
                    <TouchableOpacity style={styles.confirm} onPress={this.validateTelAndVCode}>
                        <Text style={styles.confirmText}>查询订单</Text>
                    </TouchableOpacity>
                )}
            </View>
        );
    }
}

export default InputArea;
